import { createCommandRequestId } from "./request-id.js";
const normalizeOptionalString = (value) => {
    if (value === undefined) {
        return undefined;
    }
    const normalized = value.trim();
    return normalized.length > 0 ? normalized : undefined;
};
export const createCommandEnvelope = (input) => {
    const requestId = normalizeOptionalString(input.requestId) ?? createCommandRequestId();
    const idempotencyKey = normalizeOptionalString(input.idempotencyKey) ?? requestId;
    const instanceId = normalizeOptionalString(input.instanceId);
    return {
        version: "1",
        command: input.command,
        requestId,
        idempotencyKey,
        ...(instanceId !== undefined ? { instanceId } : {}),
        ...(input.clientMeta !== undefined ? { clientMeta: input.clientMeta } : {}),
    };
};
export const createCommandEnvelopeWithInstanceId = (input) => {
    const envelope = createCommandEnvelope(input);
    if (envelope.instanceId === undefined) {
        throw new Error("instanceId must be a non-empty string");
    }
    return {
        ...envelope,
        instanceId: envelope.instanceId,
    };
};
